var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_495_8839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2063 8.85921C18.4719 8.15498 17.4964 7.7666 16.4567 7.7666H4.49333C3.45441 7.7666 2.47892 8.15498 1.74749 8.85768C1.00929 9.56038 0.603516 10.4988 0.603516 11.4992V18.6789C0.603516 19.6793 1.00927 20.6178 1.74372 21.319C2.47515 22.0232 3.45441 22.4131 4.49333 22.4131H16.4567C17.4964 22.4131 18.4756 22.0232 19.2063 21.319C19.9407 20.6148 20.3435 19.6778 20.3435 18.6789V11.4992C20.3435 10.5003 19.9407 9.56343 19.2063 8.85921ZM18.5527 18.6789C18.5527 19.2185 18.3358 19.7232 17.9399 20.1025C17.5455 20.4848 17.0166 20.6934 16.4567 20.6934H4.49333C3.93341 20.6934 3.40527 20.4848 3.00706 20.101C2.61188 19.7232 2.39505 19.2184 2.39505 18.6789V11.4992C2.39505 10.9613 2.61188 10.455 3.01011 10.0757C3.40529 9.69639 3.93343 9.48636 4.49335 9.48636H16.4567C17.0166 9.48636 17.5455 9.69639 17.9399 10.0757C18.3359 10.455 18.5527 10.9613 18.5527 11.4992V18.6789H18.5527ZM10.4754 2.30667C13.2809 2.30667 15.5613 4.49789 15.5613 7.19084H17.3521C17.3521 3.55038 14.267 0.586914 10.4754 0.586914C6.68304 0.586914 3.59794 3.55038 3.59794 7.19084H5.38872C5.3887 4.49791 7.66985 2.30667 10.4754 2.30667ZM9.58 17.2433H11.3708V14.3705H9.58V17.2433Z",
    fill: "#3D3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_495_8839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic_lock.471965ae2790e56ce3802f2798a23b34.svg";
export { ForwardRef as ReactComponent };